export default {
  category: '',
  companyId: '',
  benefitsImage: {},
  attachedFile: {},
  description: '',
  endDate: '',
  jobManagementIds: [],
  jobManagements: [],
  link: '',
  name: '',
  position: '',
  startDate: ''
};
